(($)=>{
    "use strict";

	if ( $('.video-slider').length > 0 ) {
		const prev = $('.video-slider').siblings( '.video-slider__controls' ).find( '.prev' );
		const next = $('.video-slider').siblings( '.video-slider__controls' ).find( '.next' );
		$('.video-slider').slick({
			arrows: true,
			dots: false,
			fade: true,
			infinite: false,
			autoplay: false,
			autoplaySpeed: 5000,
			speed: 500,
			prevArrow: prev,
			nextArrow: next
		});
	}

})(jQuery);